import { Badge } from "../../components/ui/badge";

export const statusLabel = {
  unread: "Unread",
  proposal_submitted: "Proposal submitted",
  declined: "Declined",
  in_progress: "Work in progress",
  completed: "Project completed",
};

const variantMap = {
  unread: "secondary",
  proposal_submitted: "outline",
  declined: "destructive",
  in_progress: "default",
  completed: "default",
};

const classMap = {
  unread: "",
  proposal_submitted: "",
  declined: "",
  in_progress: "",
  completed: "bg-emerald-600 text-white hover:bg-emerald-700",
};

export function StatusBadge({ status }) {
  if (!status || !statusLabel[status]) {
    return null;
  }

  const variant = variantMap[status] || "secondary";
  const className = classMap[status] || "";

  return (
    <Badge variant={variant as any} className={className}>
      {statusLabel[status]}
    </Badge>
  );
}
